import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { IActionFormProps } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label } from '@makyoapp/makyo-ui'

import { useForm } from '@/lib/use-form'
import { ActionInputdata } from '@/shared/action.types'
import { ActionInputV3 } from '@/components/ActionInputV3/ActionInputV3'

export default function ActFormWait({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { form, onSubmit: onFormSubmit } = useForm<ActionInputdata>({
    defaultValues: {
      value: initialData?.value || 1,
      ...((initialData || {}) as ActionInputdata),
    },
    validate(data, setError) {
      const value = data.value
      const numValue = typeof value === 'number' ? value : parseFloat(value as string)

      let isEmpty = !value && value !== 0
      let isInvalid = isEmpty || isNaN(numValue) || numValue <= 0

      setError('value', isInvalid ? 'Please enter a valid number of seconds (greater than 0)' : null)
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const value = form.getValues('value')
  const invalidForm = !value || !!form.errors

  return (
    <div>
      <div className='p-4'>
        <Field>
          <Label required>Wait Duration (seconds)</Label>

          <ActionInputV3
            options={initialData?.actionOptions}
            isActionWorkflow={initialData?.isActionWorkflow}
            inputType='number'
            columnTypes={[ColumnTypes.Number]}
            placeholder='Enter number of seconds to wait'
            value={form.getValues()}
            onChange={(value) => {
              form.setValues(value)
            }}
            error={form.errors?.value}
          />
        </Field>

        <div className='px-4 py-3 bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800/30 mt-4'>
          <div className='flex items-start gap-3'>
            <div className='flex-shrink-0 mt-0.5'>
              <svg className='w-5 h-5 text-amber-600 dark:text-amber-400' fill='currentColor' viewBox='0 0 20 20'>
                <path
                  fillRule='evenodd'
                  d='M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z'
                  clipRule='evenodd'
                />
              </svg>
            </div>
            <div className='flex-1'>
              <h4 className='text-sm font-medium text-amber-900 dark:text-amber-100 mb-1'>
                Important: Keep Browser Tab Open
              </h4>
              <div className='text-sm text-amber-700 dark:text-amber-300 space-y-1'>
                <p>When this Wait action is executing, you must keep the browser tab open:</p>
                <ul className='list-disc list-inside space-y-0.5 ml-2'>
                  <li>Do not close the browser tab or window</li>
                  <li>Do not navigate away from the current page</li>
                  <li>Keep your device awake during the wait period</li>
                </ul>
                <p className='text-xs mt-2 opacity-80'>
                  If you close the tab, the action execution will be terminated and subsequent actions in the workflow
                  may not run.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  )
}
